import React from 'react';
import { FormGroup } from '@blueprintjs/core';
import Select from 'react-select';
import { ErrorMessage } from 'formik';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import customStyles from 'utils/select-styles';
import { Colors } from '@blueprintjs/core';

const SelectGroup = ({
  changeHandler,
  name,
  options,
  value,
  label,
  getOptionLabel,
  getOptionValue,
  disabled,
  customClass,
  isMulti,
}) => {
  const handleChange = selected => {
    changeHandler(name, selected);
  };
  return (
    <FormGroup label={label} labelFor="select" className={customClass}>
      <Select
        id="select"
        value={value}
        onChange={handleChange}
        options={options}
        isSearchable
        styles={customStyles}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        isDisabled={disabled || false}
        isMulti={isMulti}
      />
      <ErrorMessage
        name={name}
        render={msg => <ErrorWrapper color={Colors.RED2}>{msg}</ErrorWrapper>}
      />
    </FormGroup>
  );
};

export default SelectGroup;
